'use strict';

var log2$1 = require('../../../../../_virtual/log2.js_commonjs-exports.js');

log2$1.__exports.__esModule = true;
var log2 = Math.log2 ? Math.log2 : function (x) {
  return Math.log(x) / Math.LN2;
};

log2$1.__exports.default = log2;
